import React from 'react';
import styles from './static-content-template.module.css';
import Button from '@ramsey-design-system/button';
import { ActionItem } from '../../../../types';

type LessonButtonProps = {
  actionItem: ActionItem;
  onComplete: any;
};

function LessonButtonComponent({
  actionItem,
  onComplete,
}: LessonButtonProps): any {
  const buttons = actionItem.body?.buttons;
  const { lesson_id, title, complete } = actionItem;

  if (!buttons) {
    return null;
  }

  return (
    <>
      {buttons.map(button => {
        const newTab = button.new_tab ? '_blank' : null;
        const dataLoggerElementId = `${button.text} CTA Button`;
        const dataLoggerElementLabel = `${lesson_id}: ${title} Action Item`;
        const isDisabled = !button.url && complete;

        let buttonType = button.button_type as any;

        /* Ramsey Design Systems does not have a 'secondary' appearnce, so this accounts for that here for now. */
        const buttonStyle =
          buttonType === 'secondary' ? (buttonType = 'ghost') : buttonType;

        return (
          <Button
            key={button.text}
            appearance={buttonStyle}
            className={styles.button}
            size="large"
            onClick={onComplete}
            href={button.url}
            target={newTab as any}
            disabled={isDisabled}
            data-testid="lesson-button"
            data-logger-element-id={dataLoggerElementId}
            data-logger-element-label={dataLoggerElementLabel}
          >
            {button.text}
          </Button>
        );
      })}
    </>
  );
}

export default LessonButtonComponent;
